import ko from "knockout";
import _ from "lodash";
import ViewModel from "viewModels/ViewModel";
import CustomerJourneyDetailsView from "viewModels/CustomerJourneyDetailsView";
import authService from "../services/authService";

/**
 * @class CustomerJourneyView
 *
 * @param  {JourneyContext[]} journeyContexts
 * @param  {KnockoutObservable<string>} sessionId (optional) the sessionId to show. Will render a CustomerJourneyDetailsView if provided.
 */
export default ViewModel.extend(function CustomerJourneyView(
    journeyContexts,
    activeCustomerJourneySessionId
) {
    const self = this;

    self.activeView = ko.observable();

    const updateActiveView = function () {
        self.activeView({
            template: "templates/customerJourneyDetails",
            viewModel: new CustomerJourneyDetailsView(journeyContexts[0]),
        });
    };

    updateActiveView(activeCustomerJourneySessionId());

    self.subscribe(activeCustomerJourneySessionId, updateActiveView);
});
